import { Component, Mixins, Prop } from 'vue-property-decorator';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { IHypotheekdeel } from '@/model/IHypotheekdeel';

@Component({})
export default class AppAflossenHypotheekdeelInfo extends Mixins(AppFiltersMixin) {
  @Prop()
  public hypotheekdeel!: IHypotheekdeel;
}
